import React from 'react';
import {
  FaShieldAlt,
  FaCamera,
  FaAward,
  FaStar,
  FaUsers,
  FaFemale,
  FaChild,
  FaCalendarAlt,
  FaMapMarkedAlt,
  FaUserShield,
  FaParking,
  FaWifi,
  FaHeadset,
  FaCheckCircle,
} from 'react-icons/fa';
import { TRUST_BADGE_DEFS, getTopTrustBadges, computeTrustBadges } from '../utils/trustBadges';
import './TrustBadge.css';

const BADGE_ICONS = {
  verified_property: FaCheckCircle,
  verified_photos: FaCamera,
  book_stay_guarantee: FaShieldAlt,
  super_host: FaStar,
  family_friendly: FaUsers,
  women_friendly: FaFemale,
  child_friendly: FaChild,
  long_stay_friendly: FaCalendarAlt,
  safe_neighborhood: FaMapMarkedAlt,
  security_24x7: FaUserShield,
  free_parking: FaParking,
  high_speed_wifi: FaWifi,
  customer_support_24x7: FaHeadset,
};

const GUARANTEE_ICONS = {
  verified_property: FaCheckCircle,
  verified_photos: FaCamera,
  final_price: FaAward,
  booking_honored: FaShieldAlt,
  stay_support: FaHeadset,
};

export const TrustBadge = ({ badgeId, compact = false, showTooltip = true }) => {
  const def = TRUST_BADGE_DEFS[badgeId];
  if (!def) return null;

  const Icon = BADGE_ICONS[badgeId] || FaShieldAlt;
  const label = compact ? def.shortLabel : def.label;

  return (
    <span
      className={`trust-badge trust-badge--${def.category} ${compact ? 'trust-badge--compact' : ''}`}
      style={{ '--trust-color': def.color, '--trust-bg': def.bg }}
      title={showTooltip ? def.description : undefined}
    >
      <Icon className="trust-badge__icon" aria-hidden="true" />
      <span className="trust-badge__label">{label}</span>
    </span>
  );
};

export const TrustBadgeRow = ({ property, limit = 4, compact = true, className = '' }) => {
  const badges = getTopTrustBadges(property, limit);
  if (!badges.length) return null;

  return (
    <div className={`trust-badge-row ${className}`} aria-label="Trust badges">
      {badges.map((def) => (
        <TrustBadge key={def.id} badgeId={def.id} compact={compact} />
      ))}
    </div>
  );
};

export const TrustBadgeStrip = ({ property, className = '' }) => {
  const ids = computeTrustBadges(property);
  if (!ids.length) return null;

  return (
    <div className={`trust-badge-strip ${className}`} aria-label="All trust badges">
      {ids.map((id) => (
        <TrustBadge key={id} badgeId={id} compact />
      ))}
    </div>
  );
};

export const GuaranteeIcon = ({ id }) => {
  const Icon = GUARANTEE_ICONS[id] || FaShieldAlt;
  return <Icon aria-hidden="true" />;
};

export default TrustBadge;
